/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { TalentPoolResponseColor } from './talentPoolResponseColor';
import type { TalentPoolResponseIcon } from './talentPoolResponseIcon';
import type { TalentPoolResponseKind } from './talentPoolResponseKind';

export interface TalentPoolResponse {
  id: string;
  name: string;
  kind: TalentPoolResponseKind;
  source: string;
  is_standard: boolean;
  disabled_filter_categories?: string[];
  icon?: TalentPoolResponseIcon;
  color?: TalentPoolResponseColor;
  default_search?: boolean;
  receives_uploads?: boolean;
  profile_count?: number | null;
  linked_count?: number | null;
  ats_connection_ids?: string[];
  created_at: string;
}
